module.exports = __webpack_public_path__ + "static/media/chemex.164088f8.svg";